import { backendApi } from "./backend.api";
import { ICategory } from "shared/models/models";
import { getSpaceId } from "shared/utils/space";

export interface ICategoryListQuery {
  spaceId?: number;
  stockId?: number;
  full?: boolean;
}

export interface ICategoryQuery {
  spaceId?: number;
  id?: number;
}

const baseUrl: string = "/category";

export const categoryApi = backendApi.injectEndpoints({
  endpoints: (build) => {
    return {
      categories: build.query<ICategory[], ICategoryListQuery>({
        query: (queryParams) => {
          const spaceId = getSpaceId();
          const params: ICategoryListQuery = { ...queryParams };
          if (spaceId) {
            params.spaceId = spaceId;
          }
          return {
            url: baseUrl,
            method: "GET",
            params: params,
          };
        },
        providesTags: (result, error, arg) =>
          result?.length
            ? [
                ...result?.map(({ id }) => ({ type: "Category" as const, id })),
                "Category",
              ]
            : ["Category"],
      }),
      getCategory: build.query<ICategory, ICategoryQuery>({
        query: (queryParams) => {
          const spaceId = getSpaceId();
          const params: ICategoryQuery = { ...queryParams };
          if (spaceId) {
            params.spaceId = spaceId;
          }
          const id = queryParams.id;
          return {
            url: `${baseUrl}/${id}`,
            method: "GET",
            params: params,
          };
        },
        transformErrorResponse: (response: { route: string | number }) =>
          response.route,
        providesTags: (item) => [{ type: "Category", id: item?.id }],
      }),
      addCategory: build.mutation<ICategory, Partial<ICategory>>({
        query: (payload) => {
          const spaceId = getSpaceId();
          const params: Partial<ICategory> = { ...payload };
          if (spaceId) {
            params.spaceId = spaceId;
          }
          return {
            url: baseUrl,
            method: "POST",
            data: params,
          };
        },
        invalidatesTags: () => ["Category"],
        transformResponse: (response: { data: ICategory }) => response.data,
      }),
      updateCategory: build.mutation<ICategory, Partial<ICategory>>({
        query: (payload) => ({
          url: `${baseUrl}/${payload.id}`,
          method: "PATCH",
          data: payload,
        }),
        invalidatesTags: (item) => [{ type: "Category", id: item?.id }],
        //transformResponse: (result, error) => [{ type: 'Visit', id: result?.id }],
      }),
      updateMultiCategory: build.mutation<ICategory[], ICategory[]>({
        query: (payload) => ({
          url: baseUrl + "/update-multi",
          method: "POST",
          data: payload,
        }),
        invalidatesTags: ["Category"],
        // transformResponse: (response: { data: IVisit[] }) => response.data,
      }),
      deleteCategory: build.mutation<ICategory, number>({
        query: (id) => ({
          url: `${baseUrl}/${id}`,
          method: "DELETE",
          credentials: "include",
        }),
        invalidatesTags: ["Category"],
      }),
    };
  },
});

export const {
  useCategoriesQuery,
  useAddCategoryMutation,
  useDeleteCategoryMutation,
  useGetCategoryQuery,
  useUpdateCategoryMutation,
  useUpdateMultiCategoryMutation,
} = categoryApi;
